import type { ExcursionRootProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";
import { useMemo } from "react";
import { useExcursionContext } from "@op/utils";

const ExcursionRoot = ({ overline, title, children }: ExcursionRootProps) => {
  const { closeUppermostExcursion } = useExcursionContext();

  const onClose = useMemo(() => {
    return () => {
      closeUppermostExcursion();
    };
  }, [closeUppermostExcursion]);

  return (
    <LazyComponent<ExcursionRootProps>
      name="ExcursionRoot"
      overline={overline}
      title={title}
      children={children}
      onClose={onClose}
    />
  );
};

export default ExcursionRoot;
